import { Box, Grid, Text } from '@domain-group/suit-theme'

import useCampaignInspections from '@hooks/useCampaignInspections'

import type { CampaignModel } from '@models/types'

import BrandedModuleHeader from '@sections/Public/packs/Campaign/components/BrandedModuleHeader'

interface InspectionsProps {
  accentColor?: string,
  campaign: CampaignModel,
}

const Inspections = (props: InspectionsProps) => {
  const { accentColor, campaign } = props

  const campaignInspectionsPayload = useCampaignInspections({
    filters: {
      campaign_id: campaign.id,
    },
  })
  const { filteredCampaignInspections, hasFilteredCampaignInspections, loading } = campaignInspectionsPayload

  if (!loading && !hasFilteredCampaignInspections) return null

  return (
    <Box
      alignItems="center"
      backgroundColor="white"
      flexDirection="column"
      justifyContent="center"
      paddingBottom="xlarge"
      paddingTop="large"
      position="relative"
    >
      <Box
        flexDirection="column"
        maxWidth={['100%', '900px']}
        paddingX="large"
        margin="0 auto"
        justifyContent="center"
        alignItems="start"
      >
        <BrandedModuleHeader accentColor={accentColor} title="open for inspection" />

        {/*
         // @ts-expect-error TS2322 */}
        <Grid gridTemplateColumns="repeat(5, 1fr)" gridRowGap="large" marginY="medium">
          {!loading && filteredCampaignInspections.map((campaignInspection, index) => {
            const { date_parts: { inspection } } = campaignInspection
            const hideBorder = index % 5 === 0

            return (
              <Box
                alignItems="flex-start"
                borderLeft={hideBorder ? '' : '1px solid'}
                borderColor="lineColor"
                flexDirection="column"
                key={campaignInspection.id}
                justifyContent="center"
                paddingLeft={hideBorder ? '0' : 'large'}
              >
                <Text fontWeight="500">{inspection?.date} {inspection.month_abbreviation}</Text>

                <Text
                  color="bodyFontLightColor"
                  fontSize="xsmall"
                  marginTop="medium"
                >
                  {`${inspection.start_12hr}${inspection.start_meridian} - 
                  ${inspection.end_12hr}${inspection.end_meridian}`}
                </Text>
              </Box>
            )
          })}
        </Grid>
      </Box>
    </Box>
  )
}

export default Inspections
